import { SensorOnlineState, SecurityOperatingMode } from '@/types/enums';

export function formatVoltage(voltage: number | undefined): string {
  if (voltage === undefined || voltage === null) return '—';
  return `${voltage.toFixed(1)}V`;
}

// Signed decimal degrees, 6 decimal places, no cardinal letters or degree
// symbol -- matches the mobile app's coordinate format exactly (confirmed
// consistent across every mobile screen: GeofencePage, MapPage, FleetPage,
// DeviceSummaryPage, BLE device info).
export function formatCoordinate(lat: number, lon: number): string {
  return `${lat.toFixed(6)}, ${lon.toFixed(6)}`;
}

export function formatSpeed(speed: number | undefined): string {
  if (speed === undefined || speed === null) return '—';
  return `${speed.toFixed(1)} kts`;
}

export function formatOnlineState(state: SensorOnlineState): string {
  switch (state) {
    case SensorOnlineState.ONLINE:
      return 'Online';
    case SensorOnlineState.OFFLINE:
      return 'Offline';
    default:
      return 'Unknown';
  }
}

export function formatSecurityMode(mode: SecurityOperatingMode): string {
  switch (mode) {
    case SecurityOperatingMode.DISARMED:
      return 'Disarmed';
    case SecurityOperatingMode.ONBOARD:
      return 'Onboard';
    case SecurityOperatingMode.AWAY:
      return 'Away';
    default:
      return 'Unknown';
  }
}

export function feetToMeters(feet: number): number {
  return feet * 0.3048;
}

export function formatFeet(feet: number): string {
  if (feet >= 5280) {
    return `${(feet / 5280).toFixed(1)} mi`;
  }
  return `${Math.round(feet)} ft`;
}

export function securityModeColor(mode: SecurityOperatingMode): string {
  switch (mode) {
    case SecurityOperatingMode.DISARMED:
      return 'text-yellow-500';
    case SecurityOperatingMode.ONBOARD:
      return 'text-teal-500';
    case SecurityOperatingMode.AWAY:
      return 'text-green-500';
    default:
      return 'text-slate-500';
  }
}
